import N8nPopover from './Popover.vue';

export default N8nPopover;
